import { connect } from 'react-redux'
import { RootState } from 'duck/store'

import AddOrganizationModal from './presentational'
import { getAddOrganizationModalState } from './duck/selectors'
import { submitAddOrganizationForm, hideAddOrganizationModal } from './duck/actions'

function mapStateToProps(state: RootState) {
  const { show, submitting } = getAddOrganizationModalState(state)
  return {
    show,
    submitting,
  }
}

export default connect(mapStateToProps, {
  onSubmit: submitAddOrganizationForm,
  onClose: hideAddOrganizationModal,
})(AddOrganizationModal)
